import { annualSolarSavings } from '../solar/selectors';
import { getITC, getMACRS } from '../tax/selectors';
import { getSRECs } from '../srecs/selectors';
import { getSMARTvalue, getMAStateTaxCredit } from '../smart/selectors';

import {
    getNYRebateTotal,
    getNYPTaxAbatement,
    getNYPTaxAbatementMosaic,
    getNYResiTaxCredit,
} from '../../common/nyserda/selectors';

export const getCustomLoanPayment = (state, year) => {
    const { cashprice } = state.solar;
    const {
        interest,
        loanTerm,
        downPayment,
    } = state.loan;

    const monthlyInterest = interest / 1200;
    const monthlyInterestPlus1 = 1 + monthlyInterest;

    const upFrontPayment = downPayment;

    const term = loanTerm;

    const payment =
        year <= term / 12
            ? (((cashprice - upFrontPayment) * monthlyInterest) /
                  (1 - 1 / monthlyInterestPlus1 ** term)) *
              12
            : 0;
    return payment;
};

export const getCustomLoanPaymentESS = (state, year) => {
    const { cashprice } = state.solar;
    const {
        interest,
        loanTerm,
        downPayment,
    } = state.loan;
    const { includeESS, essPrice } = state.ess;

    const monthlyInterest = interest / 1200;
    const monthlyInterestPlus1 = 1 + monthlyInterest;

    let price = cashprice;
    if (includeESS === true) {
        price = cashprice + essPrice;
    }

    const upFrontPayment = downPayment;

    const term = loanTerm;

    const finalPrice = price;

    const payment =
        year <= term / 12
            ? (((finalPrice - upFrontPayment) * monthlyInterest) /
                  (1 - 1 / monthlyInterestPlus1 ** term)) *
              12
            : 0;
    return payment;
};


export const getHomeLoanBeforePayment = (state) => {
    const { cashprice } = state.solar;
    const {
        mosaicTerm,
        mosaicDownPayment,
        loanProvider,
        mosaicFee,
    } = state.loan;

    let upFrontPayment = 0;
    if (loanProvider === 'mosaic') {
        upFrontPayment = mosaicDownPayment;
    }

    let finalPrice = cashprice;
    if (loanProvider === 'mosaic') {
        finalPrice = (cashprice * mosaicFee) - upFrontPayment;
    }

    let monthlyPayment = 0;
    if (mosaicTerm === 120) {
        monthlyPayment = 0.0077989 * finalPrice;
    } else if (mosaicTerm === 180) {
        monthlyPayment = 0.00609462 * finalPrice;
    } else if (mosaicTerm === 240) {
        monthlyPayment = 0.00529806 * finalPrice;
    }


    return monthlyPayment;
};

export const getHomeLoanBeforePaymentESS = (state) => {
    const { cashprice } = state.solar;
    const {
        mosaicTerm,
        mosaicDownPayment,
        loanProvider,
        mosaicFee,
    } = state.loan;
    const { includeESS, essPrice } = state.ess;

    let price = cashprice;
    if (includeESS === true) {
        price = cashprice + essPrice;
    }

    let upFrontPayment = 0;
    if (loanProvider === 'mosaic') {
        upFrontPayment = mosaicDownPayment;
    }

    let finalPrice = price;
    if (loanProvider === 'mosaic') {
        finalPrice = (price * mosaicFee) - upFrontPayment;
    }

    let monthlyPayment = 0;
    if (mosaicTerm === 120) {
        monthlyPayment = 0.0077989 * finalPrice;
    } else if (mosaicTerm === 180) {
        monthlyPayment = 0.00609462 * finalPrice;
    } else if (mosaicTerm === 240) {
        monthlyPayment = 0.00529806 * finalPrice;
    }


    return monthlyPayment;
};

export const getHomeLoanAfterPayment = (state, year) => {
    const { cashprice } = state.solar;
    const {
        mosaicTerm,
        mosaicDownPayment,
        loanProvider,
        mosaicFee,
    } = state.loan;
    const { projectState } = state.projectaddress;

    let upFrontPayment = 0;
    if (loanProvider === 'mosaic') {
        upFrontPayment = mosaicDownPayment;
    }

    let finalPrice = cashprice;
    if (loanProvider === 'mosaic') {
        finalPrice = (cashprice * mosaicFee) - upFrontPayment;
    }

    const nyRebate = getNYRebateTotal(state, year);
    const nyResiTaxCredit = getNYResiTaxCredit(state, year);

    let monthlyPayment = 0;
    if (mosaicTerm === 120 && projectState === 4) {
        monthlyPayment = 0.0077989 * (finalPrice -
            nyRebate - nyResiTaxCredit);
    } else if (mosaicTerm === 180 && projectState === 4) {
        monthlyPayment = 0.00609462 * (finalPrice -
             nyRebate - nyResiTaxCredit);
    } else if (mosaicTerm === 240 && projectState === 4) {
        monthlyPayment = 0.00529806 * (finalPrice -
            nyRebate - nyResiTaxCredit);
    } else if (mosaicTerm === 120) {
        monthlyPayment = 0.0077989 * finalPrice;
    } else if (mosaicTerm === 180) {
        monthlyPayment = 0.00609462 * finalPrice;
    } else if (mosaicTerm === 240) {
        monthlyPayment = 0.00529806 * finalPrice;
    }

    return monthlyPayment;
};
export const getHomeLoanAfterPaymentESS = (state, year) => {
    const { cashprice } = state.solar;
    const {
        mosaicTerm,
        mosaicDownPayment,
        loanProvider,
        mosaicFee,
    } = state.loan;
    const { includeESS, essPrice } = state.ess;
    const { projectState } = state.projectaddress;

    let price = cashprice;
    if (includeESS === true) {
        price = cashprice + essPrice;
    }

    let upFrontPayment = 0;
    if (loanProvider === 'mosaic') {
        upFrontPayment = mosaicDownPayment;
    }

    let finalPrice = price;
    if (loanProvider === 'mosaic') {
        finalPrice = (price * mosaicFee) - upFrontPayment;
    }

    const nyRebate = getNYRebateTotal(state, year);
    const nyResiTaxCredit = getNYResiTaxCredit(state, year);

    let monthlyPayment = 0;
    if (mosaicTerm === 120 && projectState === 4) {
        monthlyPayment = 0.0077989 * (finalPrice -
            nyRebate - nyResiTaxCredit);
    } else if (mosaicTerm === 180 && projectState === 4) {
        monthlyPayment = 0.00609462 * (finalPrice -
             nyRebate - nyResiTaxCredit);
    } else if (mosaicTerm === 240 && projectState === 4) {
        monthlyPayment = 0.00529806 * (finalPrice -
            nyRebate - nyResiTaxCredit);
    } else if (mosaicTerm === 120) {
        monthlyPayment = 0.0077989 * finalPrice;
    } else if (mosaicTerm === 180) {
        monthlyPayment = 0.00609462 * finalPrice;
    } else if (mosaicTerm === 240) {
        monthlyPayment = 0.00529806 * finalPrice;
    }

    return monthlyPayment;
};

export const annualLoanSavings = (state, prevSolarValue, year) => {
    const { projectState } = state.projectaddress;
    const {
        mosaicTerm,
        loanProvider,
        showLoan,
        mosaicDownPayment,
        downPayment,
    } = state.loan;

    let savings = 0;
    const srecs = getSRECs(state);

    const smart = getSMARTvalue(state);
    const maCredit = getMAStateTaxCredit(state, year);

    const nyRebate = getNYRebateTotal(state, 1);
    let nyAbatement = getNYPTaxAbatement(state, year) / 4;
    if (showLoan && loanProvider === 'mosaic') {
        nyAbatement = getNYPTaxAbatementMosaic(state, year) / 4;
    }
    const nyResiTaxCredit = getNYResiTaxCredit(state, 1);

    let loan = getCustomLoanPayment(state, year);

    if (loanProvider === 'mosaic') {
        loan = 0;
    }
    let mosaic = 0;
    if (year === 1 && loanProvider === 'mosaic') {
        mosaic = getHomeLoanBeforePayment(state) * 12;
    } else if (year === 2 && loanProvider === 'mosaic') {
        mosaic = getHomeLoanBeforePayment(state) * 6 + (getHomeLoanAfterPayment(state) * 6);
    } else if ((year <= mosaicTerm / 12) && loanProvider === 'mosaic') {
        mosaic = getHomeLoanAfterPayment(state) * 12;
    } else {
        mosaic = 0;
    }

    let nyIncentives = 0;
    if (projectState === 4) {
        nyIncentives = nyRebate + nyResiTaxCredit;
    }
    let mosaicPrePayment = 0;
    if (loanProvider === 'mosaic' && year === 2) {
        mosaicPrePayment = getITC(state) + nyIncentives;
    }

    let deposit = downPayment;
    if (loanProvider === 'mosaic') {
        deposit = mosaicDownPayment;
    }
    if (year === 1) {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            getMACRS(state, year) +
            getITC(state) +
            srecs[year] +
            smart[year] +
            maCredit +
            nyRebate +
            nyAbatement +
            nyResiTaxCredit -
            loan -
            mosaic -
            deposit;
    } else if (year < 5) {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] +
            smart[year] +
            nyAbatement -
            mosaicPrePayment -
            mosaic -
            loan;
    } else if (year < 6) {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] -
            loan -
            mosaic +
            smart[year];
    } else {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            smart[year] +
            srecs[year]
            - loan
            - mosaic;
    }
    return savings;
};

export const getAnnualMosaicSavings = (state, prevSolarValue, year) => {
    const { projectState } = state.projectaddress;
    const {
        mosaicTerm,
        loanProvider,
        mosaicDownPayment,
        showLoan,
    } = state.loan;

    if (!showLoan) {
        return 0;
    }


    let savings = 0;
    const srecs = getSRECs(state);

    const smart = getSMARTvalue(state);
    const maCredit = getMAStateTaxCredit(state, year);
    const nyRebate = getNYRebateTotal(state, 1);
    const nyAbatement = getNYPTaxAbatementMosaic(state, year) / 4;
    const nyResiTaxCredit = getNYResiTaxCredit(state, 1);

    let loan = getCustomLoanPayment(state, year) * 12;

    if (year === 1 && loanProvider === 'mosaic') {
        loan = getHomeLoanBeforePayment(state) * 12;
    } else if (year === 2 && loanProvider === 'mosaic') {
        loan = getHomeLoanBeforePayment(state) * 6 + (getHomeLoanAfterPayment(state) * 6);
    } else if ((year <= mosaicTerm / 12) && loanProvider === 'mosaic') {
        loan = getHomeLoanAfterPayment(state) * 12;
    } else {
        loan = 0;
    }

    let nyIncentives = 0;
    if (projectState === 4) {
        nyIncentives = nyRebate + nyResiTaxCredit;
    }
    let mosaicPrePayment = 0;
    if (loanProvider === 'mosaic' && year === 2) {
        mosaicPrePayment = getITC(state) + nyIncentives;
    }

    if (year === 1) {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            getMACRS(state, year) +
            getITC(state) +
            srecs[year] +
            smart[year] +
            maCredit +
            nyRebate +
            nyAbatement +
            nyResiTaxCredit -
            loan -
            mosaicDownPayment;
    } else if (year < 5) {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] +
            smart[year] +
            nyAbatement -
            mosaicPrePayment -
            loan;
    } else if (year < 6) {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] -
            loan +
            smart[year];
    } else {
        savings =
            annualSolarSavings(year, prevSolarValue, state) +
            smart[year] +
            srecs[year]
            - loan;
    }
    return savings;
};



// WEBPACK FOOTER //
// ./src/containers/common/loan/selectors.js